import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const profilePhotoStyles = css`
  width: 145px;
  height: 170px;
  display: block;
  padding: 60px 5px;
  text-align: center;
  background-size: cover;
  background-position: center;
  margin: 20px 0;
  color: rgba(255, 0, 0, 0);

  &.upload,
  &.nophoto {
    color: black;
  }

  &.upload,
  &.change {
    cursor: pointer;
    &:hover {
      color: red;
    }
  }

  &.nophoto {
    border: 1px solid black;
  }

  &.error {
    background-color: red;
    color: white;
  }
`;

export const ProfilePhoto = styled.div`
  ${profilePhotoStyles}
`;

export const sigCanvasStyles = css`
  border: 1px dotted black;
  &.error {
    border: 3px dotted red;
  }
`;

export const SigCanvas = styled.canvas`
  ${sigCanvasStyles}
`;

export const printableStyles = css`
  padding: 30px;
`;

export const Printable = styled.div`
  ${printableStyles}
`;

export const lineBreakStyles = css`
  white-space: pre-wrap;
`;

export const LineBreakMarkdown = styled.div`
  ${lineBreakStyles}
`;

export const singleDatePickerStyles = css`
  .SingleDatePicker_picker {
    z-index: 10;
  }
`;

export const SingleDatePickerWrapper = styled.div`
  ${singleDatePickerStyles}
`;

export const tabularMenuStyles = css`
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TabularMenu = styled.div`
  &.ui.attached.tabular.menu,
  .ui.attached.tabular.menu {
    ${tabularMenuStyles}
  }
`;
